module.exports = __webpack_public_path__ + "static/media/search.a4e6bfc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/svg/search.svg
// module id = 1033
// module chunks = 0